import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { SearchService } from '@services/search.service';
import { CreateService } from '@services/create.service';
import { GlobalService } from '@common/global';
import { SaveService } from '@services/save.service';
import * as _ from 'lodash';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { RemoveService } from '@services/remove.service';
import { RatingValueComponent } from '@app/social/rating-value/rating-value.component';
@Component({
  selector: 'app-review-list',
  templateUrl: './review-list.component.html',
  styleUrls: ['./review-list.component.sass']
})
export class ReviewListComponent implements OnInit {

  @Input('c') component: string;
  @Input('a') application: string;
  @Input('rows') rows: number;
  @Input('mediaId') mediaId: string;
  @Input('metadata') metadata: object;
  @Input('mediaType') mediaType: string;
  @Input('mediaName') mediaName: string;
  @Input('loginurl') loginurl: string;
  review_count = 0;
  btn_update_process=false;
  form_renter = false;
  reviews: any = [];
  dataLoding = false;
  params: any = [];
  pageCounter = 1;
  btn_process = false;
  isLogin = false;
  reviewRate = 0;
  mname="";
  metaReview = true;
  meta_reviews: any = [];
  meta: any = [];
  meta_count = 0;
  review_edit_show={};
  review_error: any = { "name": "", "description": "" };
  review_update_error: any = { "name": "", "description": "" };
  reviewForm: FormGroup;
  reviewEditForm:FormGroup;
  constructor(private _save: SaveService,private _remove: RemoveService,private router: Router, private _createService: CreateService, private fb: FormBuilder, private _searchService: SearchService, private _global: GlobalService) { }

  @ViewChild(RatingValueComponent, { static: false }) ratingElem: RatingValueComponent;
  ngOnInit(): void {
  
   // this.loadReview();
   this.meta =this._global.asJsonObject(this._global.getVal(this.metadata,'reviews',[]));
    if(this.meta.length>0){
      this.meta_reviews =this.meta;
      Object.entries(this.meta_reviews).forEach(([key, value]) => {
        if (value) {
          this.meta_count = this.meta_count + 1;
        }
      });
    }

    if (this._global.isAuthenticated()) {
      this.isLogin = true;
    }
    this.mname=this.mediaName;
    this.reviewForm = this.fb.group({
      name: [this.mname],
      description: []
    });

    this.reviewEditForm = this.fb.group({
      name: [],
      description: []
    });


  }
  showForm(){
    this.form_renter=true;
    this.reviewForm.get('name').setValue(this.mediaName);
  }
  rating(e) {
    this.reviewRate = e
  }

  showReviews() {
    this.dataLoding = true;
    this.metaReview = false;
    this.loadReview();
  }
  loadReview() {

    let pa = {
      component: this.component,
      application: 'review',
      start: 0,
      rows: this.rows,
      mediaId: this.mediaId,
      sortOrder: 'desc',
      sortString: 'createdTime'
    };
    this._searchService.appreview(pa).subscribe(
      reviewList => {
        this.dataLoding = false;
        if (!_.isEmpty(this._global.getVal(reviewList, 'response.docs', ''))) {
          this.params = this._global.getVal(reviewList, 'request', {});
          this.review_count = this._global.getVal(reviewList, 'response.numFound', '0');
          this.reviews = this._global.getVal(reviewList, 'response.docs', {});
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  onScrollDown() {
    if (!this.dataLoding) {
      this.dataLoding = true;
      if (this.review_count <= this.pageCounter * this.rows) {
        this.dataLoding = false;
      } else {
        let p = this._global.generateParams(this.params, ['component', 'start', 'language', 'url', 'dialect']);
        p['start'] = this.pageCounter * this.rows;
        p['component'] = this.component;
        this._searchService.appreview(p).subscribe(
          data => {
            if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
              this.reviews = this.reviews.concat(this._global.getVal(data, 'response.docs', []));
              this.dataLoding = false;
              this.pageCounter += 1;
              this.params = this._global.getVal(data, 'request', '');
            } else {
              this.dataLoding = false;
            }
          },
          error => {
            console.log("error", JSON.stringify(error));
          });

      }
    }
  }
  saveReview() {
   
    this.review_error = { "name": "", "description": "" };
    this.btn_process = true;
    let p = this.reviewForm.value;
    p = this._global.paramsRemoveNull(p);
    p['mediaName'] = this.mediaName;
    p['mediaId'] = this.mediaId
    p['application'] = 'review';
    p['status'] = 'pending';
    p['rating'] = this.reviewRate;
    p['component'] = this.component;
    p['mediaType'] = this.mediaType;
    this._createService.review(p).subscribe(
      data => {
        this.btn_process = false;
        if (data["status"] == "1") {
          let msg=this._global.getVal(data, 'message.info', '')
          this._global.showMessage({ "type": 'success',message: msg });
        
      
          if(!this.metaReview){
            let r=this.reviews;
            this.reviews=[];
            this.reviews.push(data["response"]);
            this.reviews = this.reviews.concat(r);
            }else{  
              let c=this.meta_reviews;
              this.meta_reviews = [];
              this.meta_reviews.push(data["response"]);
              this.meta_reviews = this.meta_reviews.concat(c);
              this.meta_count = this.meta_count + 1;
            }
          this.reviewForm.reset();
          this.reviewRate = 0;
          this.form_renter = false;
        } else {
          for (let key in data["errors"]) {
            this.review_error[key] = data["errors"][key]["message"];
          }
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  gotoLogin() {
    this.router.navigate(['/login'], { queryParams: { returnUrl: this.loginurl, 'navigateByUrl': true } });
  }
  edit(obj) {
    this.review_edit_show={};
    this.review_update_error ={ "name": "", "description": "" };
    this.review_edit_show[obj['id']]=true;
    console.log( this.review_edit_show)
  }
  updateCancel(){
    this.review_edit_show={};
  }
  delete( obj) {
    if (confirm("Press a button!")) {
      let p={
        component:this.component,
        application:'review',
        mediaType:this.mediaType,
        ids:obj['id']
      };
      this._remove.review(p).subscribe(
        data => {
          //this.btn_process = false;
          if (data["status"] == "1") {
            
            this._global.showMessage({ "type": 'success', "message":this._global.getVal(data,'message.info','')});
          
          } else {
            this._global.showMessage({ "type": 'success', "message":this._global.getVal(data,'message.error','')});
          
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    } else {
      console.log("You pressed Cancel!");
    }

  }
  updateReview(id,key){
    this.review_update_error = { "name": "", "description": "" };
    this.btn_update_process = true;
    let p = this.reviewEditForm.value;
    p = this._global.paramsRemoveNull(p);
    p['mediaName'] = this.mediaName;
    p['mediaId'] = this.mediaId,
    p['id'] = id,
    p['application'] = 'review';
    p['component'] = this.component;
    p['mediaType'] = this.mediaType;
    this._save.reviewUpdate(p).subscribe(
      data => {
        this.btn_update_process = false;
        if (data["status"] == "1") {
          this.review_count++;
          this._global.showMessage({ "type": 'success', "message": this._global.getVal(data,'message.info','') });
           this.review_edit_show={};
           if (!this.metaReview) {
            this.reviews[key] = data["response"];
          } else {
            this.meta_reviews[key] = data["response"];
          }
          this.reviewEditForm.reset();
          this.review_edit_show = {};
        } else {
          for (let key in data["errors"]) {
            this.review_update_error[key] = data["errors"][key]["message"];
          }
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

}
